var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAttachments = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 14.88,6.56 L 7.9,13.55 A 2.28,2.28 0 0,0 11.12,16.77 L 18.11,9.79 A 4.56,4.56 0 0,0 11.66,3.34 L 4.67,10.32 A 6.84,6.84 0 0,0 14.35,20 L 21.33,13.01",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAttachments, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/attachments.7bca2834.svg";
export { ForwardRef as ReactComponent };